'use strict';

function changeToAbsoluteUrl(el) {
	const captureElementRef = /url\(.*#(.*)\)/;
	const elementId = el.getAttribute('fill').match(captureElementRef)[1];
	el.setAttribute('fill', 'url(' + window.location.href + '#' + elementId + ')');
}

/**
 * Set absolute svg urls
 *
 * In Safari the fill=url(#ref) is not working when we have a base url.
 * To work around this we need absolute urls before the id reference.
 *
 * @param {string} svgContainerSelector
 */
function pmtSetAbsoluteSvgUrls(svgContainerSelector) {
	Array.from(document.querySelectorAll(svgContainerSelector + ' [fill^=url]')).forEach(
		changeToAbsoluteUrl
	);
}

/**
 * With delay
 *
 * Set timeout is used as a workaround to fix render issue when using product and account
 * switch in places and social media. Without it the svg linearGradients gets the full
 * absolute urls but the change is still not reflected in the UI.
 *
 * A full page refresh does work without the setTimeout, strangely open in new tab when
 * changing products does not. With a setTimeout all seem to work, both ELm and Angular
 * picks up the changes in fill=(absoluteUrl + #elementRef) in the svgs.
 *
 * Emulated network speed slowdown does not seem to affect the workaround.
 *
 * @param {string} svgContainerSelector
 * @param {number} delay
 */
function withDelay(svgContainerSelector, delay = 10) {
	setTimeout(function () {
		pmtSetAbsoluteSvgUrls(svgContainerSelector);
	}, delay);
}

window.pmtSetAbsoluteSvgUrls = pmtSetAbsoluteSvgUrls;
window.pmtSetAbsoluteSvgUrlsWithDelay = withDelay;
